"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeautifyThemeColors = void 0;
exports.BeautifyThemeColors = [
    "primary",
    "neutral",
    "storm-dust",
    "mecha-red",
    "leaf",
    "mecha-yellow",
    "tangerine",
    "grape",
    "theme-background",
    "header-white",
    "black",
    "white",
    "mecha-white",
    "mecha-border",
    "input-background",
    "mecha-shadow",
    "input-border",
    "login-input-background",
    "login-hover-background",
    "login-input-placeholder",
    "disabled-button-color",
    //transparent
    "transparent",
    //Completely dynamic textbox-styles according to latest design system changes done on 30-03-2023
    "textbox-default-background",
    "textbox-hover-background",
    "textbox-focus-background",
    "textbox-placeholder-default-color",
    "textbox-placeholder-hover-color",
    "textbox-placeholder-focus-color",
    "textbox-default-border-color",
    "textbox-hover-border-color",
    "search-bar",
    "blog-card-text",
];
//# sourceMappingURL=data:application/json;base64,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